import React, { useEffect } from "react";
// import { Button } from "react-bootstrap";
import { __ } from "services/Translator";
import { Link } from "react-router-dom";
import { useLocation, useHistory } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ls from "services/ls";

export default function ThemeSettings(props) {
  const history = useHistory();
  const location = useLocation();
  // location.pathname == "/games/specialty

  useEffect(() => {
    if (location.pathname === "/sports-betting") {
      props.setLandingType("sport");
    } else {
      props.setLandingType("casino");
    }
  }, [location]);

  return (
    <div className="theme_select">
      <div className="themes">
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip>{__("Casino")}</Tooltip>}
        >
          <Link
            className={
              props.landingType === "casino"
                ? "single_btn casino active"
                : "single_btn casino"
            }
            to="/"
            onClick={() => {
              props.setLandingType("casino");
              ls.set("selectedTheme", "casino");
            }}
          >
            <div className="icon">
              <svg
                width="26px"
                viewBox="0 0 60 60"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs></defs>

                <title />

                <g data-name="Layer 2" id="Layer_2">
                  <g id="Icons">
                    <g id="Gambling">
                      <rect class="cls-1" height="60" width="60" />

                      <path
                        class="cls-2"
                        d="M12.63,14.77a1,1,0,0,0-.91,1.08l.09,1.08a1,1,0,0,0,1,.91h.09a1,1,0,0,0,.91-1.09l-.1-1.07A1,1,0,0,0,12.63,14.77Z"
                      />

                      <path
                        class="cls-2"
                        d="M51.23,34.21,48.82,31.8a12.45,12.45,0,0,0-8.58-20.64l.08-1.92A2.41,2.41,0,0,0,38,6.72L17.53,5.78A2.41,2.41,0,0,0,15,8.08L14.87,11l-4.67.41A2.41,2.41,0,0,0,8,14l3,33.85a2.43,2.43,0,0,0,2.62,2.2l13.82-1.21L32,53.45a2.65,2.65,0,0,0,1.18.68,2.61,2.61,0,0,0,1.36,0l12.24-3.28A2.61,2.61,0,0,0,48.63,49l3.28-12.23A2.66,2.66,0,0,0,51.23,34.21ZM47.42,30.4l-1.29-1.29a9,9,0,0,0,1.08-1.67l1.72.61A10.81,10.81,0,0,1,47.42,30.4ZM40,17a6.65,6.65,0,0,1,4.74,10.71l-2.44-2.44a2.65,2.65,0,0,0-2.54-.68l-.11,0Zm9.61,9.18-1.7-.61A9.14,9.14,0,0,0,48.09,23l1.78-.32A10.21,10.21,0,0,1,49.58,26.16Zm-.06-5.41-1.8.33a8.84,8.84,0,0,0-1.08-2.28L48,17.61A10.42,10.42,0,0,1,49.52,20.75Zm-5.63-6.63a10.65,10.65,0,0,1,2.86,2l-1.4,1.19a8.75,8.75,0,0,0-2.08-1.43ZM42,13.45l-.61,1.72A8.36,8.36,0,0,0,40.06,15l.08-1.8A10.29,10.29,0,0,1,42,13.45ZM17,8.17a.42.42,0,0,1,.44-.4l20.49,1a.41.41,0,0,1,.4.43l-.74,16-1,.27-1.2-13.76a2.43,2.43,0,0,0-2.62-2.2L16.88,10.84ZM13.41,48.09a.42.42,0,0,1-.45-.37L10,13.87a.42.42,0,0,1,.38-.45l22.57-2a.41.41,0,0,1,.44.38l1.24,14.12-3.34.89a5.77,5.77,0,0,0-.83-.88L23,19.7a1,1,0,0,0-1.41.12l-6.26,7.45a5.39,5.39,0,0,0,.41,7.43,5.28,5.28,0,0,0,4.59,1.22,5.75,5.75,0,0,1-1,1.35,1,1,0,0,0-.22,1.14A1,1,0,0,0,20,39h.09l3.09-.27L22.35,42A2.64,2.64,0,0,0,23,44.49L25.57,47ZM23.76,36.67l-1.63.14a6.49,6.49,0,0,0,.31-.59,1.72,1.72,0,0,0-.25-1.92,1.69,1.69,0,0,0-1.83-.47,3.25,3.25,0,0,1-3.28-.62,3.38,3.38,0,0,1-.2-4.65l5.61-6.69,6.61,5.55-1.61.43a2.63,2.63,0,0,0-1.86,1.86ZM46.7,48.47a.64.64,0,0,1-.45.45L34,52.2A.64.64,0,0,1,33.4,52l-8.95-9a.61.61,0,0,1-.17-.61l3.28-12.24a.64.64,0,0,1,.45-.45L40.24,26.5h0a.69.69,0,0,1,.32,0,.66.66,0,0,1,.29.17l9,9a.62.62,0,0,1,.17.61Z"
                      />

                      <path
                        class="cls-2"
                        d="M37,37.78l-5.21-5.2A1,1,0,1,0,30.35,34l5.21,5.2a1.15,1.15,0,0,1,.29,1.09l-1.91,7.11a1,1,0,0,0,.71,1.23,1.09,1.09,0,0,0,.26,0,1,1,0,0,0,1-.74l1.91-7.11A3.12,3.12,0,0,0,37,37.78Z"
                      />

                      <path
                        class="cls-2"
                        d="M46.39,36.87a1,1,0,0,0-1.22-.7L40.54,37.4a1,1,0,0,0-.7,1.23,1,1,0,0,0,1,.74,1.15,1.15,0,0,0,.26,0l4.62-1.24A1,1,0,0,0,46.39,36.87Z"
                      />

                      <path
                        class="cls-2"
                        d="M30.46,44.89a2.53,2.53,0,0,0,.6,2.23c.52.53,1.1.38,1.29-.34a2.53,2.53,0,0,0-.6-2.23C31.23,44,30.65,44.18,30.46,44.89Z"
                      />

                      <path
                        class="cls-2"
                        d="M29.73,37.62a2.53,2.53,0,0,0-.6-2.23c-.52-.52-1.1-.37-1.29.34a2.53,2.53,0,0,0,.6,2.23C29,38.49,29.54,38.34,29.73,37.62Z"
                      />

                      <path
                        class="cls-2"
                        d="M31,42.2a2.53,2.53,0,0,0-.6-2.23c-.52-.52-1.1-.37-1.29.34a2.53,2.53,0,0,0,.6,2.23C30.27,43.07,30.85,42.92,31,42.2Z"
                      />

                      <path
                        class="cls-2"
                        d="M40,33.27A.71.71,0,0,0,40.3,32a2.54,2.54,0,0,0-2.23-.6.7.7,0,0,0-.34,1.29A2.53,2.53,0,0,0,40,33.27Z"
                      />

                      <path
                        class="cls-2"
                        d="M46,39.92a2.54,2.54,0,0,0-1.63,1.64c-.19.71.24,1.13,1,.94A2.55,2.55,0,0,0,47,40.86C47.18,40.15,46.75,39.73,46,39.92Z"
                      />

                      <path
                        class="cls-2"
                        d="M39.18,46.55a2.55,2.55,0,0,0-1.63,1.63c-.19.71.24,1.13,1,.94a2.54,2.54,0,0,0,1.64-1.63C40.33,46.77,39.9,46.36,39.18,46.55Z"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div className="text">{__("Casino")}</div>
          </Link>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip>{__("Poker")}</Tooltip>}
        >
          <Link
            className={
              props.landingType === "poker"
                ? "single_btn poker active"
                : "single_btn poker"
            }
            onClick={() => {
              props.setLandingType("poker");
              ls.set("selectedTheme", "poker");
            }}
          >
            <div className="icon">
              <svg
                width="28px"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="#000000"
                  d="M150.156 82.406c-1.843.092-3.663.446-5.344 1.063L41.094 121.53c-4.483 1.645-8.493 5.357-10.5 9.69-2.007 4.33-2.238 9.798-.594 14.28l66.72 181.875c1.643 4.482 5.354 8.524 9.686 10.53 4.332 2.008 9.8 2.24 14.28.595l103.72-38.063c4.483-1.644 8.493-5.355 10.5-9.687l.03-.063c1.982-4.322 2.2-9.757.564-14.218L168.78 94.593c-1.635-4.46-5.318-8.484-9.624-10.5l-.062-.03c-2.166-1.005-4.623-1.556-7.094-1.658-.618-.025-1.23-.03-1.844 0zM189.22 96.03l63.843 174c3.41 9.3 2.975 19.61-1.188 28.595-4.163 8.986-11.734 15.965-21.03 19.375l-27.44 10.063 60 2.78c4.77.223 9.91-1.66 13.44-4.874 3.528-3.217 5.87-8.17 6.092-12.94l9-193.5c.222-4.768-1.628-9.938-4.843-13.468-3.216-3.53-8.168-5.87-12.938-6.093l-84.937-3.94zm121 33.25l-8.626 184.626c-.46 9.893-4.836 19.237-12.156 25.906-7.32 6.67-17.014 10.148-26.907 9.688l-26.06-1.22 69.374 23.095c4.53 1.507 10.012 1.107 14.28-1.03 4.27-2.14 7.838-6.283 9.345-10.814l61.155-183.81c1.507-4.532 1.107-10.013-1.03-14.282-2.14-4.27-6.283-7.87-10.814-9.375l-68.56-22.782zm-205.064 18.345c24.458 24.936 68.02 17.74 80.75 45.53 11.875 25.927-14.51 46.006-37.97 38.407l17 30.782-18.78 6.906-10.937-31.688c-10.39 22.624-43.053 23.746-54.157-.53-13.53-29.577 24.02-54.2 24.093-89.407zm301.438 39.22L347.22 365.437c-3.127 9.397-9.865 17.19-18.72 21.625l-.094.03c-8.834 4.396-19.07 5.116-28.437 2l-20.376-6.78 43.312 37.03c3.63 3.102 8.865 4.78 13.625 4.407 4.76-.374 9.618-2.84 12.72-6.47l125.875-147.31c3.102-3.63 4.78-8.835 4.406-13.595-.372-4.76-2.87-9.648-6.5-12.75l-66.436-56.78z"
                />
              </svg>
            </div>
            <div className="text">{__("Poker")}</div>
          </Link>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip>{__("Bingo")}</Tooltip>}
        >
          <Link
            className={
              props.landingType === "bingo"
                ? "single_btn bingo active"
                : "single_btn bingo"
            }
            onClick={() => {
              props.setLandingType("bingo");
              ls.set("selectedTheme", "bingo");
            }}
          >
            <div className="icon">
              <svg
                width="30px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="6"
                  stroke="#000000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
                <circle
                  cx="12"
                  cy="4"
                  r="2"
                  stroke="#000000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
                <circle
                  cx="19"
                  cy="8"
                  r="2"
                  stroke="#000000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
                <circle
                  cx="5"
                  cy="8"
                  r="2"
                  stroke="#000000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
                <circle
                  cx="5"
                  cy="16"
                  r="2"
                  stroke="#000000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
                <circle
                  cx="19"
                  cy="16"
                  r="2"
                  stroke="#000000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
                <path
                  d="M8 22L12 12L16 22"
                  stroke="#000000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
              </svg>
            </div>
            <div className="text">{__("Bingo")}</div>
          </Link>
        </OverlayTrigger>
        {/* <img
          src={require("../assets/images/new-landing/icons/card-1.png").default}
          alt="Card-Icon"
        /> */}
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip>{__("Sport")}</Tooltip>}
        >
          <Link
            className={
              props.landingType === "sport"
                ? "single_btn sport active"
                : "single_btn sport"
            }
            to="/sports-betting"
            onClick={() => {
              props.setLandingType("sport");
              ls.set("selectedTheme", "sport");
            }}
          >
            <div className="icon">
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>sports-volleyball-solid</title>
                <g id="Layer_2" data-name="Layer 2">
                  <g id="invisible_box" data-name="invisible box">
                    <rect width="48" height="48" fill="none" />
                  </g>
                  <g id="Q3_icons" data-name="Q3 icons">
                    <g>
                      <path d="M23.9,22.3a14.5,14.5,0,0,0,4.2-5.4c-5.6-3-19.9-2.8-25.9,4.2a20.9,20.9,0,0,0-.1,5C7.8,21.4,17.8,19.4,23.9,22.3Z" />
                      <path d="M29.2,14.1c1.3-3.9,1.6-8.1.6-11.3A21.9,21.9,0,0,0,5,13a17.7,17.7,0,0,0-1.5,3.1C11.1,11.2,23,11,29.2,14.1Z" />
                      <path d="M12.8,24.4c-4,.9-7.8,2.7-10.1,5.2A22.3,22.3,0,0,0,13,43.1a21.6,21.6,0,0,0,14.4,2.6C19.3,41.6,13.2,31.3,12.8,24.4Z" />
                      <path d="M22.5,24.9a14.2,14.2,0,0,0-6.7-.9c.2,6.3,7.5,18.6,16.6,20.3a21.1,21.1,0,0,0,4.4-2.4C29.8,39.3,23.1,31.6,22.5,24.9Z" />
                      <path d="M25.5,24.8a14.6,14.6,0,0,0,2.6,6.3c5.4-3.3,12.3-15.8,9.3-24.5A14.6,14.6,0,0,0,35,4.9L33.1,4C34.3,11.3,31,21,25.5,24.8Z" />
                      <path d="M41.1,10.2c.5,9-5.3,19.5-11.1,23.3,2.7,3,6.2,5.4,9.5,6.1A17.5,17.5,0,0,0,43,35,21.8,21.8,0,0,0,41.1,10.2Z" />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div className="text">{__("Sports")}</div>
          </Link>
        </OverlayTrigger>
      </div>
    </div>
  );
}
